import React, { forwardRef, useImperativeHandle, useState } from 'react'
import { Modal, notification } from 'antd'
import { useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'

import { toggleAccount, changeAccountForChecker } from '../../common/request'
import ResponseCode from '../../common/response-code'
import Styles from './ToggleAccountModal.module.scss'

const CHECKER_ROLE_TAGS = ['checker', 'applyRechecker']

const ToggleAccountModal = forwardRef((props, ref) => {
  const [modalVisible, setModalVisible] = useState(false)
  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useSearchParams()
  const userInfo = useSelector(state => state.userInfo.userInfo)
  const envInfo = useSelector(state => state.env.envInfo)

  useImperativeHandle(ref, () => {
    return {
      showModal
    }
  })

  const showModal = () => {
    setModalVisible(true)
  }

  const hideModal = () => {
    setModalVisible(false)
  }

  const isCheckerRoleSwitch = (currentAccount, targetAccount) => {
    const currentRoleTag = currentAccount?.roleTag || userInfo.currentRoleTag
    const targetRoleTag = targetAccount?.roleTag
    return CHECKER_ROLE_TAGS.includes(currentRoleTag) && CHECKER_ROLE_TAGS.includes(targetRoleTag)
  }

  const handleToggleSuccess = (res) => {
    setLoading(false)
    if (res.code === ResponseCode.success && res.data) {
      sessionStorage.setItem('access_token', res.data.token)
      sessionStorage.setItem('token_header', res.data.tokenHead)
      notification.success({
        message: '操作成功'
      })
      hideModal()
      setSearch('')
      window.location.reload()
    } else {
      Modal.error({
        title: '错误',
        content: res.msg
      })
    }
  }

  const handleToggleError = (err) => {
    setLoading(false)
    console.error(err)
    Modal.error({
      title: '错误',
      content: '网络错误，切换账号失败'
    })
  }

  const toggleAccountAction = (selectItem) => {
    if (props.currentAccount.accountId === selectItem.accountId) {
      return
    }

    setLoading(true)
    const request = isCheckerRoleSwitch(props.currentAccount, selectItem)
      ? changeAccountForChecker({
        accountId: selectItem.accountId,
        area: envInfo.name
      })
      : toggleAccount({ accountId: selectItem.accountId })

    request.then(handleToggleSuccess).catch(handleToggleError)
  }

  const getRoleItemClass = (isActive) => {
    if (isActive) {
      return [Styles.accountItem, Styles.isActive].join(' ')
    } else {
      return Styles.accountItem
    }
  }

  const generateRoleItem = () => {
    return props.accountList.map(account => {
      return <div
        className={ getRoleItemClass(props.currentAccount.accountId === account.accountId) }
        key={ account.accountId }
        onClick={ toggleAccountAction.bind(this, account) }
      >
        { `${ account.name }(${ account.roleName })` }
      </div>
    })
  }

  return (<>
    <div ref={ ref }>
      <Modal
        title={ '切换身份' }
        open={ modalVisible }
        confirmLoading={ loading }
        onCancel={ hideModal }
        footer={ [] }
      >
        <div className={ 'exam-list-wrap' }>
          { generateRoleItem() }
        </div>
      </Modal>
    </div>
  </>)
})

export default ToggleAccountModal
